/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="m12 0 5.6327 1.1493V3.013h4.8979v5.7464c0 .414-.3289.7496-.7347.7496-.4057 0-.7347-.3356-.7347-.7496V4.5121h-3.4285v4.2473c0 .414-.329.7496-.7347.7496-.4058 0-.7347-.3356-.7347-.7496V2.3782L12 1.5288l-4.1633.8494v6.3812c0 .414-.3289.7496-.7347.7496-.4057 0-.7347-.3356-.7347-.7496v-3.15l-3.4285.4305v2.7195c0 .414-.329.7496-.7347.7496-.4058 0-.7347-.3356-.7347-.7496V4.714l4.898-.615V1.1493L12 0ZM23.2653 12.5071c.4058 0 .7347-.3356.7347-.7495 0-.414-.3289-.7496-.7347-.7496H16.898c-.4058 0-.7347.3356-.7347.7496 0 2.3457-1.864 4.2473-4.1633 4.2473-2.2993 0-4.1633-1.9016-4.1633-4.2473 0-.414-.3289-.7496-.7347-.7496H.7347c-.4058 0-.7347.3356-.7347.7496 0 .4139.329.7495.7347.7495h.76c.0954 1.413.4586 2.7509 1.0383 3.9612l-.6564.3866c-.3514.207-.4718.6654-.269 1.0239.203.3585.6523.4813 1.0037.2743l.6576-.3873c.7564 1.142 1.7225 2.1275 2.8418 2.8993l-.3796.6708c-.2029.3585-.0825.8169.2689 1.0239.3514.207.8007.0842 1.0036-.2743l.379-.6697a10.3064 10.3064 0 0 0 3.8827 1.0594v.7753c0 .4139.3289.7495.7347.7495s.7347-.3356.7347-.7495v-.7753a10.3066 10.3066 0 0 0 3.8827-1.0594l.379.6697c.2029.3585.6522.4813 1.0036.2743.3514-.207.4718-.6654.2689-1.0239l-.3796-.6708c1.1193-.7718 2.0854-1.7573 2.8418-2.8993l.6576.3873c.3514.207.8007.0842 1.0036-.2743.2029-.3585.0825-.8169-.2689-1.0239l-.6564-.3866c.5797-1.2103.9429-2.5482 1.0384-3.9612h.7599Z"
    />
    <path
      fill="currentColor"
      d="M9.3061 4.762c0-.414.329-.7496.7347-.7496h3.9184c.4057 0 .7347.3355.7347.7495 0 .414-.329.7495-.7347.7495h-3.9184c-.4057 0-.7347-.3355-.7347-.7495ZM10.0408 7.0105c-.4057 0-.7347.3356-.7347.7495 0 .414.329.7496.7347.7496h3.9184c.4057 0 .7347-.3356.7347-.7496 0-.414-.329-.7495-.7347-.7495h-3.9184Z"
    />
  </React.Fragment>,
  'MenuInfrastructureFilled'
);
